import Vue from "vue";
import VueRouter from "vue-router";
import _ from "lodash";
import store from "@/store";

import memberPaths from "./path.member";
// import lockerPaths from './path.locker'
import minigamePaths from "./path.minigame";
import tournamentPaths from "./path.tournament";
import bookingPaths from "./path.booking";
import roomPaths from "./path.room";
import settingPaths from "./path.setting";
import fittingPaths from "./path.fitting";
import i18n from "@/i18n";

Vue.use(VueRouter);

let allowNullName = ["Login", "Logout"];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Main",
      component: () => import(/* webpackChunkName: "main" */ "@/views/Main"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "main",
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login"),
      meta: {
        layout: "NoneLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.login.shop_login"),
        step: [i18n.t("page.login.shop_login")],
      },
    },
        {
      path: "/guide",
      name: 'Guide',
      component: () => import( "@/views/Guide"),
      meta: {
        layout: 'DefaultLayout'
      }
    },
    {
      path: "/logout",
      name: "Logout",
      beforeEnter: (to, from, next) => {
        // auth.logout(sessionStorage.getItem('token'), (flag, data) => {
        //   console.log(flag)
        // })
        store.dispatch("logout");
        next("/login");
      },
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404"),
      meta: {
        layout: "NoneLayout",
      },
    },
  ],
});

router.addRoute(memberPaths);
router.addRoute(minigamePaths);
router.addRoute(tournamentPaths);
// router.addRoute(lockerPaths)
router.addRoute(bookingPaths);
router.addRoute(roomPaths);
router.addRoute(settingPaths);
router.addRoute(fittingPaths);

router.beforeEach(async (to, from, next) => {
  console.log("to", to);
  console.log("from", from);
  if (from.meta && to.meta && to.meta.sub_menu_num !== from.meta.sub_menu_num) {
    //console.log(1111);

    console.log("to", to);
    console.log("from", from);
    if (
      from.meta &&
      to.meta &&
      from.name &&
      to.meta.menu_num !== from.meta.menu_num
    ) {
      console.log("beforeEachto", to);
      console.log("beforeEachfrom", from);
      store.commit("setSearchData", {});
    }

    // if (from.matched[0] && to.matched[0]) {
    //   if (
    //     (from.matched[0].path !== "/member" ||
    //       to.matched[0].path !== "/member") &&
    //     (from.matched[0].path !== "/booking" ||
    //       to.matched[0].path !== "/booking")
    //   ) {
    //     store.commit("setSearchData", {});
    //   }
    // }
  }
  if (!to.matched.length) {
    next("/notFound");
  } else {
    if (_.includes(allowNullName, to.name)) {
      if (
        to.name === "Login" &&
        (localStorage.getItem("token") || sessionStorage.getItem("token"))
      ) {
        alert(i18n.t('alert.login.already_logged_in'));
        next({
          path: "/",
          replace: true,
        });
      }
      next();
    } else if (
      !localStorage.getItem("token") &&
      !sessionStorage.getItem("token")
    ) {
      store.dispatch("logout");
      next({
        path: "/login",
        replace: true,
      });
    } else {
      next();
    }
  }
});

export default router;
